import { render } from "./page-not-found.vue?vue&type=template&id=5e68c148&scoped=true"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"

import "./page-not-found.vue?vue&type=style&index=0&id=5e68c148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e68c148"]])

export default __exports__